import { render, staticRenderFns } from "./vendors_tel.vue?vue&type=template&id=359d36f0&scoped=true&"
import script from "./vendors_tel.vue?vue&type=script&lang=js&"
export * from "./vendors_tel.vue?vue&type=script&lang=js&"
import style0 from "./vendors_tel.vue?vue&type=style&index=0&id=359d36f0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "359d36f0",
  null
  
)

export default component.exports